import { TranslocoTestingModule, TranslocoTestingOptions } from '@jsverse/transloco';

export function getTranslocoModule(scope: string, options: TranslocoTestingOptions = {}) {
  return TranslocoTestingModule.forRoot({
    langs: { [scope]: {} },
    translocoConfig: {
      availableLangs: ['en'],
      defaultLang: 'en',
    },
    preloadLangs: true,
    ...options,
  });
}
